import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import {Recognition} from "@irati/types"
import modalStory, {anyStoriesOpen} from "@irati/utils/modalStory"
import History from "@irati/utils/history"
import GenericModal from "@irati/ui/src/GenericModal"
import Spacing from "@irati/ui/src/Spacing"

import {ModalHeader} from "../shared/Modal"
import ViewRecognition from "./ViewRecognition"

export const VIEW_RECOGNITION = "VIEW_RECOGNITION"

const modals = [VIEW_RECOGNITION]

interface Props {
  redirectToFeed: boolean,
  recognition: Recognition,
  onAfterExitModal: () => void
}

interface State {
  show: {[key: string]: string}
}

class RecognitionsPopup extends Component<Props, State> {
  state = {
    show: modalStory(modals, VIEW_RECOGNITION)
  }

  static defaultProps = {
    redirectToFeed: false,
    onAfterExitModal: null
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  show = (modalToShow = VIEW_RECOGNITION) =>
    this.setState({
      show: modalStory(modals, modalToShow)
    })

  handleHide = () =>
    this.setState({
      show: modalStory(modals, null)
    })

  handleAfterExit = () => {
    const {redirectToFeed, onAfterExitModal} = this.props
    if (!anyStoriesOpen(this.state.show)) {
      if (redirectToFeed) {
        History.push("/polls", this.context, false)
      }
      if (typeof onAfterExitModal === "function") {
        onAfterExitModal()
      }
    }
  }

  render() {
    const {show} = this.state
    const {recognition} = this.props

    return (
      <Fragment>
        <GenericModal show={show[VIEW_RECOGNITION]} onHide={this.handleHide} onExited={this.handleAfterExit} hideActions>
          <Spacing marginBottom={1}>
            <ModalHeader users={recognition.receivers.results} size={150} />
          </Spacing>
          <ViewRecognition recognition={recognition} onArchive={this.handleHide} />
        </GenericModal>
      </Fragment>
    )
  }
}

export default RecognitionsPopup
